module.exports = __webpack_public_path__ + "img/1738905805379_B8B8942F-7995-4fe2-BC40-1DF5362D5473.2e8031f1.png";